const displayName = (data) => {
    const { preferredName, firstName, lastName } = data;
    return `${preferredName || firstName} ${lastName}`;
};

export { displayName };
